import dispatcher from '../dispatchers/dispatcher';
import { Constants, ActionUtils } from "../utils";
import $ from "jquery";

export const ACTIONS = {
    UPDATE_USER_LISTINFO: 'actions.getUserListInfo',
    UPDATE_USER_CREATORLISTINFO: 'actions.getUserCreatorListInfo',
    UPDATE_USER_ACCOUNTINFO: 'actions.getUserAccountInfo',
    UPDATE_SPOOFED_USER_ACCOUNTINFO: 'actions.getSpoofedUserAccountInfo',
    UPDATE_USER_FAVORITESINFO: 'actions.getUserFavoritesInfo',
    UPDATE_USER_SHAREDINFO: 'actions.getUserSharedInfo',
    UPDATE_USER_LAYOUTINFO: 'actions.getUserLayoutInfo',
    UPDATE_USER_THEMEINFO: 'actions.updateUserThemeInfo',
    UPDATE_USER_SHARE_ADDED: 'actions.addUserShare',
    UPDATE_USER_FAVORITE_ADDED: 'actions.addUserFavorite',
    UPDATE_USER_FAVORITE_REMOVED: 'actions.removeUserFavorite',
    UPDATE_USER_HIGHSCOREINFO: 'actions.getUserHighScores',
    UPDATE_USER_TOPUSERSHIGHSCOREINFO: 'actions.getTopUsersHighScores',
    UPDATE_USER_PERMISSIONLISTINFO: 'actions.getUserPermissionListInfo',
    UPDATE_USER_PERMISSIONREMOVED: 'actions.removeUserPermission',
    UPDATE_USER_USERSWITHPERMISSIONSLISTINFO: 'actions.getUsersWithPermissionsListInfo',
    UPDATE_RESOURCE_REPORTTYPELISTINFO: 'actions.getReportTypeListInfo',
    UPDATE_RESOURCE_QRSYEARLISTINFO: 'actions.getQRSYearListInfo',
    UPDATE_RESOURCE_RANKLISTINFO: 'actions.getRankListInfo',
    UPDATE_RESOURCE_RESOURCETYPELISTINFO: 'actions.getResourceTypeListInfo',
    UPDATE_RESOURCE_OPTIMIZEDINTELLISENSEINFO: 'actions.getOptimizedResourceIntellisenseInfo',
    UPDATE_RESOURCE_INTELLISENSEINFO: 'actions.getResourceIntellisenseInfo',
    UPDATE_RESOURCE_LISTBYTYPEINFO: 'actions.getResourceListByType',
    UPDATE_RESOURCE_RELATIONSHIPINFO: 'actions.getResourceRelationshipInfo',
    UPDATE_RESOURCE_SEARCHRELATIONSHIPINFO: 'actions.getResourceSearchRelationshipInfo',
    UPDATE_RESOURCE_TOPREPORTSINFO: 'actions.getTopReportsInfo',
    UPDATE_RESOURCE_NEWESTREPORTSINFO: 'actions.getnewestReportsInfo',
    UPDATE_RESOURCE_TOPRATEDREPORTSINFO: 'actions.getTopRatedReportsInfo',
    UPDATE_RESOURCE_TOPTAGSINFO: 'actions.getTopTagsInfo',
    UPDATE_USER_RATINGSINFO: 'actions.getUserRatingsInfo',
    UPDATE_USER_VIEWED_RESOURCE: 'actions.addResourceView',
    UPDATE_USER_RATING_UPVOTE: 'actions.upvoteResource',
    UPDATE_USER_RATING_DOWNVOTE: 'actions.downvoteResource',
    UPDATE_USER_RATING_REMOVED: 'actions.removeResourceVote',
    UPDATE_RESOURCE_IMAGE_UPLOAD: 'actions.addResourceImage',
    UPDATE_RESOURCE_ACCESS_REQUEST: 'actions.addResourceAccessRequest',
    UPDATE_RESOURCE_IMAGE_REMOVED: 'actions.removeResourceImage',
    UPDATE_RESOURCE_THUMB_IMAGEINFO: 'actions.getResourceImages',
    UPDATE_RESOURCE_FULLIMAGEINFO: 'actions.getResourceFullImages',
    UPDATE_RESOURCE_SINGLESYNC: 'actions.resyncSingleResource',
    UPDATE_RESOURCE_GETSINGLERESOURCE: 'actions.getSingleResource',
    UPDATE_RESOURCE_MANUALALLSYNC: 'actions.manualResyncAllResources',
    UPDATE_RESOURCE_RANKREMOVED: 'actions.removeRank',
    UPDATE_RESOURCE_RANKADDED: 'actions.addRank',
    UPDATE_RESOURCE_RANKEDITTED: 'actions.editRank',
    UPDATE_RESOURCE_TAGINFO: 'actions.getResourceTagInfo',
    UPDATE_RESOURCE_REPORTANDMETRICLINKINFO: 'actions.getReportsAndMetricLinkInfo',
    UPDATE_SINGLERESOURCE_TAGINFO: 'actions.getSingleResourceTagInfo',
    UPDATE_SINGLERESOURCE_TAGADDED: 'actions.createSingleResourceTag',
    UPDATE_SINGLERESOURCE_TAGREMOVED: 'actions.removeSingleResourceTag',
    UPDATE_SINGLERESOURCE_IMAGEINFO: 'actions.getSingleResourceImages',
    UPDATE_SINGLERESOURCE_RELATIONSHIPINFO: 'actions.getSingleResourceRelationships',
    UPDATE_SINGLERESOURCE_APGOALSINFO: 'actions.getSingleResourceAPGoals',
    UPDATE_SINGLERESOURCE_APGOALSADDED: 'actions.createSingleResourceAPGoals',
    UPDATE_SINGLERESOURCE_APGOALSREMOVED: 'actions.removeSingleResourceAPGoals',
    UPDATE_SINGLERESOURCE_MODIFYAPGOALS: 'actions.modifySingleResourceAPGoals',
    UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESINFO: 'actions.getSingleResourceAPGoalsLinkedResources',
    UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESADDED: 'actions.createSingleResourceAPGoalsLinkedResource',
    UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESREMOVED: 'actions.removeSingleResourceAPGoalsLinkedResource',
    UPDATE_SINGLERESOURCE_APACTIONSINFO: 'actions.getSingleResourceAPActions',
    UPDATE_SINGLERESOURCE_APACTIONSADDED: 'actions.createSingleResourceAPActions',
    UPDATE_SINGLERESOURCE_APACTIONSREMOVED: 'actions.removeSingleResourceAPActions',
    UPDATE_SINGLERESOURCE_MODIFYAPACTIONS: 'actions.modifySingleResourceAPActions',
    UPDATE_SINGLERESOURCE_APTEAMINFO: 'actions.getSingleResourceAPTeam',
    UPDATE_SINGLERESOURCE_APTEAMADDED: 'actions.createSingleResourceAPTeam',
    UPDATE_SINGLERESOURCE_APTEAMREMOVED: 'actions.removeSingleResourceAPTeam',
    UPDATE_SINGLERESOURCE_APLOGINFO: 'actions.getSingleResourceAPLog',
    UPDATE_SINGLERESOURCE_APLOGADDED: 'actions.createSingleResourceAPLog',
    UPDATE_SINGLERESOURCE_APLOGREMOVED: 'actions.removeSingleResourceAPLog',
    UPDATE_SINGLERESOURCE_METRICOWNERINFO: 'actions.getSingleResourceMetricOwner',
    UPDATE_SINGLERESOURCE_METRICOWNERADDED: 'actions.createSingleResourceMetricOwner',
    UPDATE_SINGLERESOURCE_METRICOWNERREMOVED: 'actions.removeSingleResourceMetricOwner',
    UPDATE_SINGLERESOURCE_METRICGOALSINFO: 'actions.getSingleResourceMetricGoals',
    UPDATE_SINGLERESOURCE_METRICGOALSADDED: 'actions.createSingleResourceMetricGoals',
    UPDATE_SINGLERESOURCE_METRICGOALSREMOVED: 'actions.removeSingleResourceMetricGoals',
    UPDATE_SINGLERESOURCE_MODIFYMETRICGOALS: 'actions.modifySingleResourceMetricGoals',
    UPDATE_SINGLERESOURCE_MODIFYAPLOG: 'actions.modifySingleResourceAPLog',
    UPDATE_SINGLERESOURCE_CCNATTRIBUTEINFO: 'actions.getSingleResourceCCNAttributes',
    UPDATE_SINGLERESOURCE_RELATIONSHIPADDED: 'actions.addSingleResourceRelationship',
    UPDATE_SINGLERESOURCE_MODIFYSINGLERESOURCE: 'actions.modifySingleResource',
    UPDATE_SINGLERESOURCE_MODIFYSINGLERESOURCECCNATTRIBUTES: 'actions.modifySingleResourceCCNAttributes',
    UPDATE_SINGLERESOURCE_CREATESINGLERESOURCE: 'actions.createSingleResource',
    UPDATE_SINGLERESOURCE_RELATIONSHIPREMOVED: 'actions.removeSingleResourceRelationship',
    UPDATE_SINGLERESOURCE_DISPLAYSININFO: 'actions.getSingleResourceDisplaysIn',
    UPDATE_SINGLERESOURCE_GOALIMPORTED: 'actions.importCSVGoal',
    UPDATE_POSTJIRATICKET_SENT: 'actions.postJIRATicket',
    UPDATE_FEEDBACK_SENT: 'actions.sendFeedback',
    UPDATE_USER_WEATHERINFO: 'actions.getWeatherInfo',
    UPDATE_ACCESSGROUPS: 'actions.getAccessGroups',
    UPDATE_EMPLOYEE_SEARCH_LIST: 'actions.getEmployeeSearchList',
    UPDATE_EMPLOYEE_ACCESSGROUPS: 'actions.getEmployeeAccessGroups',
    UPDATE_EMPLOYEE_ACCESSGROUP_ADDED: 'actions.addEmployeeAccessGroup',
    UPDATE_EMPLOYEE_ACCESSGROUP_REMOVED: 'actions.removeEmployeeAccessGroup',
    UPDATE_ACTIONGROUP_FORMDATA_UPLOADED: 'actions.uploadActionGroupFormData',
    UPDATE_ACTIONGROUP_FILELIST: 'actions.getActionGroupFileList',
    UPDATE_ACTIONGROUP_FILEDOWNLOADED: 'actions.getActionGroupFileDownload',
    UPDATE_ACTIONGROUP_FILE_REMOVED: 'actions.removeActionGroupFile',
    UPDATE_USER_VALIDATEDINFO: 'actions.validateAccess_Success',
    UPDATE_USER_FAILEDVALIDATEDINFO: 'actions.validateAccess_Failed',
};

function downloadBase64File(base64Data, fileType, fileName) {
    // Convert the Base64 data to binary
    const binaryData = atob(base64Data);
    const dataArray = new Uint8Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
        dataArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob with the binary data and type
    const blob = new Blob([dataArray], { type: fileType });

    if (blob.size === 0) {
        throw new Error('Empty file received');
    }

    // Create a download link and trigger the download
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName; // Set the desired filename here
    anchor.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
}

export function getActionGroupFileList() {
    fetch('api/App/getActionGroupFileList', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_ACTIONGROUP_FILELIST,
                data: data
            })
        });
}

export function getActionGroupFileDownload(fileId, fileName) {
    fetch('/api/App/getActionGroupFileDownload', {
        method: 'POST',
        headers: { "Content-Type": "application/json; charset=utf-8", "Response-Type": "arraybuffer" },
        body: JSON.stringify({
            fileId: fileId,
            fileName: fileName
        })
    }).then(res => 
        res.arrayBuffer()
    ).then(buffer =>
    {
        const myBlob = new Blob([buffer],
            { type: 'application/octet-stream' });
        saveBlobAs(myBlob, fileName);
    })
    .then(data => {
        dispatcher.dispatch({
            type: ACTIONS.UPDATE_ACTIONGROUP_FILEDOWNLOADED,
            data: data
        })
    });

}



export function getActionGroupFileView(externalId,fileName) {
    fetch('/api/App/getActionGroupFileView', {
        method: 'POST',
        headers: { "Content-Type": "application/json; charset=utf-8", "Response-Type": "arraybuffer" },
        body: JSON.stringify({
            externalId: externalId
        })
    }).then(res =>
        res.arrayBuffer()
    ).then(buffer => {
        const myBlob = new Blob([buffer],
            { type: 'text/plain' });
        saveBlobAs(myBlob, fileName);
    })
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_ACTIONGROUP_FILEDOWNLOADED,
                data: data
            })
        });
}



export function getActionGroupFileAdminDownload(fileId) {
    // Make a fetch call to get the file data
    fetch('api/App/getFileByFileId', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            fileId: fileId
        })
    })
        .then(response => response.json())
        .then(result => {
            if (!result || !result.FILE) {
                throw new Error('Invalid or incomplete file data received');
            }

            downloadBase64File(result.FILE.split(',')[1], result.FILE_TYPE, result.FILE_NAME);
        })
        .catch(error => {
            console.error("Error:", error);
        });
}


export function getActionGroupFileEligibilityAndDownload(externalId, userId) {
    fetch('api/App/getActionGroupEligibility', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            userId: userId,
        })
    })
        .then(response => response.json())
        .then(data => {
            if (data === true) {
                // Make another fetch call
                fetch('api/App/getFile', {
                    method: "POST",
                    headers: { "Content-Type": "application/json; charset=utf-8" },
                    body: JSON.stringify({
                        externalId: externalId
                    })
                })
                    .then(response => response.json())
                    .then(result => {
                        if (!result || !result.FILE) {
                            throw new Error('Invalid or incomplete file data received');
                        }

                        downloadBase64File(result.FILE.split(',')[1], result.FILE_TYPE, result.FILE_NAME);
                    })
            } else {
                // Display an alert if not eligible
                alert("You must be granted access to this file group, or the file has been removed.");
            }
        })
        .catch(error => {
            console.error("Error:", error);
        });
}


export function removeActionGroupFile(fileId) {
    fetch("api/App/removeActionGroupFile?fileId=" + fileId, {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_ACTIONGROUP_FILE_REMOVED,
                data: data
            })
        });
}

function saveBlobAs(blob, fileName) {
    const a = document.createElement("a");
    let url = blob;
    url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}

export function getAccessGroups() {
    fetch('api/App/getAccessGroups', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_ACCESSGROUPS,
                data: data
            })
        });
};

export function getEmployeeAccessGroups(userId) {
    fetch('api/App/getEmployeeAccessGroups?userId=' + userId, {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUPS,
                data: data
            })
        });
};

export function getEmployeeSearchList(searchString) {
    fetch("api/App/getEmployeeSearchList?searchString=" + searchString, {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_EMPLOYEE_SEARCH_LIST,
                data: data
            })
        });
};

export function addEmployeeAccessGroup(groupid, userid) {
    fetch('api/App/addEmployeeAccessGroup', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            userId: userid,
            accessGroupId: groupid
        })
    })
    .then(response => response.json())
    .then(data => {
        dispatcher.dispatch({
            type: ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUP_ADDED,
            data: data
        })
    });
} 

export function removeEmployeeAccessGroup(groupid, userid) {
    fetch('api/App/removeEmployeeAccessGroup', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            userId: userid,
            accessGroupId: groupid
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUP_REMOVED,
                data: data
            })
        });
}


export function getUserListInfo() {
    fetch('api/App/getUserListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_LISTINFO,
                data: data
            })
        });
};

export function uploadActionGroupFormData(formData) {
    $.ajax({
        url: "api/App/uploadActionGroupFormData",
        type: Constants.HTTP_METHOD.POST,
        contentType: false,
        processData: false,
        data: formData,
        success: data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_ACTIONGROUP_FORMDATA_UPLOADED,
                data: data
            })
        }
    });
}


export function getUserCreatorListInfo() {
    fetch('api/App/getUserCreatorListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_CREATORLISTINFO,
                data: data
            })
        });
};


export function getReportTypeListInfo() {
    fetch('api/App/getReportTypeListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_REPORTTYPELISTINFO,
                data: data
            })
        });
};




export function getQRSYearListInfo() {
    fetch('api/App/getQRSYearListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_QRSYEARLISTINFO,
                data: data
            })
        });
};

export function getRankListInfo() {
    fetch('api/App/getRankListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RANKLISTINFO,
                data: data
            })
        });
};


export function getUserPermissionListInfo() {
    fetch('api/App/getUserPermissionListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_PERMISSIONLISTINFO,
                data: data
            })
        });
};

export function addRank(rankName, hexBackgroundColor, points, isFilterable, isInAllResults, description) {
    fetch('api/App/addRank', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            rankName: rankName,
            hexBackgroundColor: hexBackgroundColor,
            points: points,
            isFilterable: isFilterable,
            isInAllResults: isInAllResults,
            description: description
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RANKADDED,
                data: data
            })
        });
};

export function debugLog(log) {
    fetch('api/App/debugLog', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            log: log
        })
    })
        .then(response => response.json());
};


export function editRank(idRank, rankName, hexBackgroundColor, points, isFilterable, isInAllResults, description) {
    fetch('api/App/editRank', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idRank: idRank,
            rankName: rankName,
            hexBackgroundColor: hexBackgroundColor,
            points: points,
            isFilterable: isFilterable,
            isInAllResults: isInAllResults,
            description: description
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RANKEDITTED,
                data: data
            })
        });
};


export function removeRank(idRank) {
    fetch('api/App/removeRank', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idRank: idRank
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RANKREMOVED,
                data: data
            })
        });
};


export function removeUserPermission(ADUsername, UserDomain) {
    fetch('api/App/removeUserPermission', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            ADUsername: ADUsername,
            UserDomain: UserDomain
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_PERMISSIONREMOVED,
                data: data
            })
        });
};

export function addUserPermission(idUser, permissionLevel) {
    fetch('api/App/addUserPermission', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idUser: idUser,
            permissionLevel: permissionLevel
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_PERMISSIONADDED,
                data: data
            })
        });
};


export function getUsersWithPermissionsListInfo() {
    fetch('api/App/getUsersWithPermissionsListInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_USERSWITHPERMISSIONSLISTINFO,
                data: data
            })
        });
};

export function getResourceTypeListInfo(siteMode) {
    fetch('api/App/getResourceTypeListInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            siteMode: siteMode
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RESOURCETYPELISTINFO,
                data: data
            })
        });
};

export function getEpicUserAccountInfo(username, domain, cryptHash) {
    fetch('api/App/getEpicUserAccountInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            username: username,
            domain: domain,
            cryptHash: cryptHash
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_ACCOUNTINFO,
                data: data
            })
        });
};


export function getEpicHyperdriveUserAccountInfo(username, domain) {
    fetch('api/App/getEpicHyperdriveUserAccountInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            username: username,
            domain: domain
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_ACCOUNTINFO,
                data: data
            })
        });
};


export function getSpoofedEpicUserAccountInfo(username, domain) {
    fetch('api/App/getSpoofedEpicUserAccountInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            username: username,
            domain: domain
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_ACCOUNTINFO,
                data: data
            })
        });
};


export function validateAccess() {
    fetch('api/App/validateAccess', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => {
            // Check if the response was successful
            if (response.ok) {
                // Process the successful response
                return;
            } else {
                // Throw an error to be caught by the catch() block
                throw new Error('Request failed');
            }
        })
        .then(data => {
            console.log(data);
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_VALIDATEDINFO,
                data: data
            })
        })
        .catch(error => {
            // Handle the error or return a response
            console.error(error);
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_FAILEDVALIDATEDINFO,
                })
            // Return a response or perform additional actions
            return { error: error.message };
        });
};


export function getUserAccountInfo() {
    fetch('api/App/getUserAccountInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => {
            // Check if the response was successful
            if (response.ok) {
                // Process the successful response
                return response.json();
            } else {
                // Throw an error to be caught by the catch() block
                throw new Error('Request failed');
            }
        })
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_ACCOUNTINFO,
                data: data
            })
        })
        .catch(error => {

            // Handle the error or return a response
            console.error(error);
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_USER_FAILEDVALIDATEDINFO,
            })
            // Return a response or perform additional actions
            return { error: error.message };
        });
};




export function getExternalUserAccountInfo(username) {
    fetch('api/App/getExternalUserAccountInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            username: username
        })
    })
    .then(response => response.json())
    .then(data => {
        dispatcher.dispatch({
            type: ACTIONS.UPDATE_USER_ACCOUNTINFO,
            data: data
        })
    });
};


    export function getSpoofedUserAccountInfo(username, domain) {
        fetch('api/App/getSpoofedUserAccountInfo/' + domain + '/' + username, {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SPOOFED_USER_ACCOUNTINFO,
                    data: data
                })
            });
    };

    /*
    
    export function getOptimizedResourceIntellisenseInfo() {
        fetch('api/App/getOptimizedResourceIntellisenseInfo', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_OPTIMIZEDINTELLISENSEINFO,
                    data: data
                })
            });
    };
    
    */

    export function getQuickResourceIntellisenseInfo(siteMode) {
        fetch('api/App/getQuickResourceIntellisenseInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                siteMode: siteMode
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_INTELLISENSEINFO,
                    data: data
                })
            });
    };

    export function getResourceIntellisenseInfo(siteMode) {
        fetch('api/App/getResourceIntellisenseInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                siteMode: siteMode
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_INTELLISENSEINFO,
                    data: data
                })
            });
    };

    export function getResourceListByType(siteMode, resourceName, resourceType, reportType) {
        fetch('api/App/getResourceListByType', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                siteMode: siteMode,
                resourceName: resourceName,
                resourceType: resourceType,
                reportType: reportType
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_LISTBYTYPEINFO,
                    data: data
                })
            });
    };


export function getResourceRelationshipInfo(siteMode) {
    fetch('api/App/getResourceRelationshipInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            siteMode: siteMode
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_RELATIONSHIPINFO,
                data: data
            })
        });
};



    export function getResourceDisplaysIn(destinationExternalIds) {

        fetch('api/App/getResourceDisplaysIn', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                destinationExternalIds: destinationExternalIds
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_DISPLAYSININFO,
                    data: data
                })
            });

    };

    export function getTopReportsInfo() {
        fetch('api/App/getTopReportsInfo', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_TOPREPORTSINFO,
                    data: data
                })
            });
    };


export function getTopRatedReportsInfo() {
    fetch('api/App/getTopRatedReportsInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_TOPRATEDREPORTSINFO,
                data: data
            })
        });
};

export function getTopTagsInfo() {
    fetch('api/App/getTopTagsInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_TOPTAGSINFO,
                data: data
            })
        });
};


    export function getNewestReportsInfo() {
        fetch('api/App/getNewestReportsInfo', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_NEWESTREPORTSINFO,
                    data: data
                })
            });
    };

    export function getUserRatingsInfo() {
        fetch('api/App/getUserRatingsInfo', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_RATINGSINFO,
                    data: data
                })
            });
    };


    export function addResourceView(idUser, externalId) {
        fetch('api/App/addResourceView', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_VIEWED_RESOURCE,
                    data: data
                })
            });
    };


    export function upvoteResource(idUser, externalId) {
        fetch('api/App/upvoteResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_RATING_UPVOTE,
                    data: data
                })
            });
    };

    export function downvoteResource(idUser, externalId) {
        fetch('api/App/downvoteResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_RATING_DOWNVOTE,
                    data: data
                })
            });
    };

    export function removeResourceVote(idUser, externalId) {
        fetch('api/App/removeResourceVote', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_RATING_REMOVED,
                    data: data
                })
            });
    };



    export function resyncSingleResource(externalId) {
        fetch('api/App/resyncSingleResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_SINGLESYNC,
                    data: data
                })
            });
    };


    export function getSingleResource(externalId) {
        fetch('api/App/getSingleResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_GETSINGLERESOURCE,
                    data: data
                })
            });
    };

    export function getUserLayoutInfo(idUser) {
        fetch('api/App/getUserLayoutInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_LAYOUTINFO,
                    data: data
                })
            });
    };

    export function updateUserThemeInfo(idUser, theme) {
        fetch('api/App/updateUserThemeInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                theme: theme
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_THEMEINFO,
                    data: data
                })
            });
    };


    export function updateLayoutContentInfo(idUser, user_LayoutLeft, user_LayoutMiddle, user_LayoutRight, interfaceColumns) {
        fetch('api/App/updateLayoutContentInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                user_LayoutLeft: user_LayoutLeft,
                user_LayoutMiddle: user_LayoutMiddle,
                user_LayoutRight: user_LayoutRight,
                interfaceColumns: interfaceColumns
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_LAYOUTCONTENTINFO,
                    data: data
                })
            });
    };


    export function getUserFavoritesInfo(idUser) {
        fetch('api/App/getUserFavoritesInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_FAVORITESINFO,
                    data: data
                })
            });
    };

    export function getUserSharedInfo(idUser) {
        fetch('api/App/getUserSharedInfo', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_SHAREDINFO,
                    data: data
                })
            });
    };


    export function addUserShare(idUser, firstName, lastName, email, sharedIdUser, externalId, resourceName, resourceType) {
        fetch('api/App/addUserShare', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                firstName: firstName,
                lastName: lastName,
                email: email,
                sharedIdUser: sharedIdUser,
                externalId: externalId,
                resourceName: resourceName,
                resourceType: resourceType
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_SHARE_ADDED,
                    data: data
                })
            });
    };


    export function addUserFavorite(idUser, externalId) {
        fetch('api/App/addUserFavorite', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_FAVORITE_ADDED,
                    data: data
                })
            });
    };

    export function removeUserFavorite(idUser, externalId) {
        fetch('api/App/removeUserFavorite', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_FAVORITE_REMOVED,
                    data: data
                })
            });
    };

    export function addResourceImage(idUser, externalId, imageFileName, imageType, thumb_imageBase64, original_imageBase64) {
        fetch('api/App/addResourceImage', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                externalId: externalId,
                imageFileName: imageFileName,
                imageType: imageType,
                thumb_imageBase64: thumb_imageBase64,
                original_imageBase64: original_imageBase64
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_IMAGE_UPLOAD,
                    data: data
                })
            });
    };

    export function addResourceAccessRequest(idUser, firstName, lastName, email, adUsername, userDomain, jobTitle, externalId, resourceName, resourceType, reportType, requestReason) {
        fetch('api/App/addResourceAccessRequest', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                firstName: firstName,
                lastName: lastName,
                email: email,
                adUsername: adUsername,
                userDomain: userDomain,
                jobTitle: jobTitle,
                externalId: externalId,
                resourceName: resourceName,
                resourceType: resourceType,
                reportType: reportType,
                requestReason: requestReason
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_ACCESS_REQUEST,
                    data: data
                })
            });
    };


    export function postJIRATicket(idUser, firstName, lastName, email, phoneNumber, adUsername, userDomain, jobTitle, subject, description) {
        fetch('api/App/postJIRATicket', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneNumber: phoneNumber,
                adUsername: adUsername,
                userDomain: userDomain,
                jobTitle: jobTitle,
                subject: subject,
                description: description
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_POSTJIRATICKET_SENT,
                    data: data
                })
            });
    };



    export function sendFeedback(idUser, firstName, lastName, email, adUsername, userDomain, jobTitle, feedbackText) {
        fetch('api/App/sendFeedback', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser,
                firstName: firstName,
                lastName: lastName,
                email: email,
                adUsername: adUsername,
                userDomain: userDomain,
                jobTitle: jobTitle,
                feedbackText: feedbackText
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_FEEDBACK_SENT,
                    data: data
                })
            });
    };

    export function removeResourceImage(externalId, imageBase64) {
        fetch('api/App/removeResourceImage', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                imageBase64: imageBase64
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_IMAGE_REMOVED,
                    data: data
                })
            });
};

export function getResourceTagInfo() {
    fetch('api/App/getResourceTagInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_TAGINFO,
                data: data
            })
        });
};

export function getReportsAndMetricLinkInfo() {
    fetch('api/App/getReportsAndMetricLinkInfo', {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" }
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_RESOURCE_REPORTANDMETRICLINKINFO,
                data: data
            })
        });
};

export function getSingleResourceTagInfo(externalId) {
    fetch('api/App/getSingleResourceTagInfo', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_TAGINFO,
                data: data
            })
        });
};



export function createSingleResourceTag(externalId, tag, createdByUserDomain, createdByADUsername) {
    fetch('api/App/createSingleResourceTag', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            tag: tag,
            createdByUserDomain: createdByUserDomain,
            createdByADUsername: createdByADUsername
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_TAGADDED,
                data: data
            })
        });
};

export function removeSingleResourceTag(externalId, tag) {
    fetch('api/App/removeSingleResourceTag', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            tag: tag
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_TAGREMOVED,
                data: data
            })
        });
};




    export function getSingleResourceImages(externalId) {
        fetch('api/App/getSingleResourceImages', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_IMAGEINFO,
                    data: data
                })
            });
    };


    export function getSingleResourceRelationships(externalId, siteMode) {
        fetch('api/App/getSingleResourceRelationships', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                siteMode: siteMode
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPINFO,
                    data: data
                })
            });
    };


    export function getSingleResourceAPGoals(externalId) {
        fetch('api/App/getSingleResourceAPGoals', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSINFO,
                    data: data
                })
            });
    };


    export function createSingleResourceAPGoals(externalId, title, overviewFullText, dtGoalExpectedCompletion, createdByUserDomain, createdByADUsername) {
        fetch('api/App/createSingleResourceAPGoals', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                title: title,
                overviewFullText: overviewFullText,
                dtGoalExpectedCompletion: dtGoalExpectedCompletion,
                createdByUserDomain: createdByUserDomain,
                createdByADUsername: createdByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSADDED,
                    data: data
                })
            });
    };

    export function removeSingleResourceAPGoals(idExternalResource_APGoals) {
        fetch('api/App/removeSingleResourceAPGoals', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APGoals: idExternalResource_APGoals
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSREMOVED,
                    data: data
                })
            });
    };


    export function modifySingleResourceAPGoals(idExternalResource_APGoals, title, overviewFullText, dtGoalExpectedCompletion, dtGoalCompleted, completionFeedback, modifiedByUserDomain, modifiedByADUsername) {
        fetch('api/App/modifySingleResourceAPGoals', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APGoals: idExternalResource_APGoals,
                title: title,
                overviewFullText: overviewFullText,
                dtGoalExpectedCompletion: dtGoalExpectedCompletion,
                dtGoalCompleted: dtGoalCompleted,
                completionFeedback: completionFeedback,
                modifiedByUserDomain: modifiedByUserDomain,
                modifiedByADUsername: modifiedByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPGOALS,
                    data: data
                })
            });
    };



    export function getSingleResourceAPGoalsLinkedResources(externalId) {
        fetch('api/App/getSingleResourceAPGoalsLinkedResources', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESINFO,
                    data: data
                })
            });
    };

    export function createSingleResourceAPGoalsLinkedResource(sourceExternalId, sourceExternalId_APGoals, linkedResourceExternalId) {
        fetch('api/App/createSingleResourceAPGoalsLinkedResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                sourceExternalId: sourceExternalId,
                sourceExternalId_APGoals: sourceExternalId_APGoals,
                linkedResourceExternalId: linkedResourceExternalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESADDED,
                    data: data
                })
            });
    };

    export function removeSingleResourceAPGoalsLinkedResource(idExternalResource_APGoals_LinkedResource) {
        fetch('api/App/removeSingleResourceAPGoalsLinkedResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APGoals_LinkedResource: idExternalResource_APGoals_LinkedResource
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESREMOVED,
                    data: data
                })
            });
    };




    export function getSingleResourceAPActions(externalId, siteMode) {
        fetch('api/App/getSingleResourceAPActions', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSINFO,
                    data: data
                })
            });
    };


    export function createSingleResourceAPActions(idExternalResource_APGoals, externalId, title, overviewFullText, numHoursExpected, createdByUserDomain, createdByADUsername) {
        fetch('api/App/createSingleResourceAPActions', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APGoals: idExternalResource_APGoals,
                externalId: externalId,
                title: title,
                overviewFullText: overviewFullText,
                numHoursExpected: numHoursExpected,
                createdByUserDomain: createdByUserDomain,
                createdByADUsername: createdByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSADDED,
                    data: data
                })
            });
    };

    export function removeSingleResourceAPActions(idExternalResource_APActions) {
        fetch('api/App/removeSingleResourceAPActions', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APActions: idExternalResource_APActions
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSREMOVED,
                    data: data
                })
            });
    };


    export function modifySingleResourceAPActions(idExternalResource_APActions, idExternalResource_APGoals, title, overviewFullText, numHoursExpected, modifiedByUserDomain, modifiedByADUsername) {
        fetch('api/App/modifySingleResourceAPActions', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APActions: idExternalResource_APActions,
                idExternalResource_APGoals: idExternalResource_APGoals,
                title: title,
                overviewFullText: overviewFullText,
                numHoursExpected: numHoursExpected,
                modifiedByUserDomain: modifiedByUserDomain,
                modifiedByADUsername: modifiedByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPACTIONS,
                    data: data
                })
            });
    };





    export function getSingleResourceAPTeam(externalId) {
        fetch('api/App/getSingleResourceAPTeam', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APTEAMINFO,
                    data: data
                })
            });
    };



    export function createSingleResourceAPTeam(externalId, idUser, designation, createdByUserDomain, createdByADUsername) {
        fetch('api/App/createSingleResourceAPTeam', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                idUser: idUser,
                designation: designation,
                createdByUserDomain: createdByUserDomain,
                createdByADUsername: createdByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APTEAMADDED,
                    data: data
                })
            });
    };

    export function removeSingleResourceAPTeam(idExternalResource_APTeam) {
        fetch('api/App/removeSingleResourceAPTeam', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APTeam: idExternalResource_APTeam
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APTEAMREMOVED,
                    data: data
                })
            });
    };






export function getSingleResourceMetricOwner(externalId) {
    fetch('api/App/getSingleResourceMetricOwner', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERINFO,
                data: data
            })
        });
};



export function createSingleResourceMetricOwner(externalId, idUser, designation, createdByUserDomain, createdByADUsername) {
    fetch('api/App/createSingleResourceMetricOwner', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            idUser: idUser,
            designation: designation,
            createdByUserDomain: createdByUserDomain,
            createdByADUsername: createdByADUsername
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERADDED,
                data: data
            })
        });
};

export function removeSingleResourceMetricOwner(idExternalResource_MetricOwner) {
    fetch('api/App/removeSingleResourceMetricOwner', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idExternalResource_MetricOwner: idExternalResource_MetricOwner
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERREMOVED,
                data: data
            })
        });
};




export function importCSVGoal(externalId, fileName, goalValue, goalExpectedCompletionDate, UserDomain, ADUsername ) {
    fetch('api/App/createSingleResourceMetricOwner', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            fileName: fileName,
            goalValue: goalValue,
            goalExpectedCompletionDate: goalExpectedCompletionDate,
            UserDomain: UserDomain,
            ADUsername: ADUsername
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_GOALIMPORTED,
                data: data
            })
        });
};







export function getSingleResourceMetricGoals(externalId) {
    fetch('api/App/getSingleResourceMetricGoals', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSINFO,
                data: data
            })
        });
};


export function createSingleResourceMetricGoals(externalId, title, goalValue, goalType, locationType, dtGoalExpectedCompletion, dtStartDate, createdByUserDomain, createdByADUsername) {
    fetch('api/App/createSingleResourceMetricGoals', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            externalId: externalId,
            title: title,
            goalValue: goalValue,
            goalType: goalType,
            locationType: locationType,
            dtGoalExpectedCompletion: dtGoalExpectedCompletion,
            dtStartDate: dtStartDate,
            createdByUserDomain: createdByUserDomain,
            createdByADUsername: createdByADUsername
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSADDED,
                data: data
            })
        });
};

export function removeSingleResourceMetricGoals(idExternalResource_MetricGoals) {
    fetch('api/App/removeSingleResourceMetricGoals', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idExternalResource_MetricGoals: idExternalResource_MetricGoals
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSREMOVED,
                data: data
            })
        });
};


export function modifySingleResourceMetricGoals(idExternalResource_MetricGoals, title, goalValue, goalType, locationType, dtGoalExpectedCompletion, dtStartDate, dtGoalCompleted, completionFeedback, modifiedByUserDomain, modifiedByADUsername) {
    fetch('api/App/modifySingleResourceMetricGoals', {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
            idExternalResource_MetricGoals: idExternalResource_MetricGoals,
            title: title,
            goalValue: goalValue,
            goalType: goalType,
            locationType: locationType,
            dtGoalExpectedCompletion: dtGoalExpectedCompletion,
            dtStartDate: dtStartDate,
            dtGoalCompleted: dtGoalCompleted,
            completionFeedback: completionFeedback,
            modifiedByUserDomain: modifiedByUserDomain,
            modifiedByADUsername: modifiedByADUsername
        })
    })
        .then(response => response.json())
        .then(data => {
            dispatcher.dispatch({
                type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYMETRICGOALS,
                data: data
            })
        });
};












    export function getSingleResourceAPLog(externalId) {
        fetch('api/App/getSingleResourceAPLog', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APLOGINFO,
                    data: data
                })
            });
    };



    export function createSingleResourceAPLog(idExternalResource_APActions, externalId, numHoursUsed, overviewFullText, userDomain, ADUsername, firstName, lastName, email, createdByUserDomain, createdByADUsername) {
        fetch('api/App/createSingleResourceAPLog', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APActions: idExternalResource_APActions,
                externalId: externalId,
                numHoursUsed: numHoursUsed,
                overviewFullText: overviewFullText,
                userDomain: userDomain,
                ADUsername: ADUsername,
                firstName: firstName,
                lastName: lastName,
                email: email,
                createdByUserDomain: createdByUserDomain,
                createdByADUsername: createdByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APLOGADDED,
                    data: data
                })
            });
    };

    export function removeSingleResourceAPLog(idExternalResource_APLog) {
        fetch('api/App/removeSingleResourceAPLog', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APLog: idExternalResource_APLog
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_APLOGREMOVED,
                    data: data
                })
            });
    };


    export function modifySingleResourceAPLog(idExternalResource_APLog, idExternalResource_APActions, dtLogged, numHoursUsed, overviewFullText, userDomain, ADUsername, firstName, lastName, email, modifiedByUserDomain, modifiedByADUsername) {
        fetch('api/App/modifySingleResourceAPLog', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idExternalResource_APLog: idExternalResource_APLog,
                idExternalResource_APActions: idExternalResource_APActions,
                dtLogged: dtLogged,
                numHoursUsed: numHoursUsed,
                overviewFullText: overviewFullText,
                userDomain: userDomain,
                ADUsername: ADUsername,
                firstName: firstName,
                lastName: lastName,
                email: email,
                modifiedByUserDomain: modifiedByUserDomain,
                modifiedByADUsername: modifiedByADUsername
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPLOG,
                    data: data
                })
            });
    };



    export function getSingleResourceCCNAttributes(externalId) {
        fetch('api/App/getSingleResourceCCNAttributes', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_CCNATTRIBUTEINFO,
                    data: data
                })
            });
    };




    export function removeSingleResourceRelationship(sourceExternalId, externalId) {
        fetch('api/App/removeSingleResourceRelationship', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                sourceExternalId: sourceExternalId,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPREMOVED,
                    data: data
                })
            });
    };

    export function addSingleResourceRelationship(sourceExternalId, externalId) {
        fetch('api/App/addSingleResourceRelationship', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                sourceExternalId: sourceExternalId,
                externalId: externalId
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPADDED,
                    data: data
                })
            });
    };


    export function modifySingleResource(externalId, resourceName, resourceType, reportType, qrsYear, reportLocation, overviewFullText, createdByFirstName, createdByLastName, modifiedByFirstName, modifiedByLastName, externalStatus, rankName) {
        fetch('api/App/modifySingleResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                resourceName: resourceName,
                resourceType: resourceType,
                reportType: reportType,
                qrsYear: qrsYear,
                reportLocation: reportLocation,
                overviewFullText: overviewFullText,
                createdByFirstName: createdByFirstName,
                createdByLastName: createdByLastName,
                modifiedByFirstName: modifiedByFirstName,
                modifiedByLastName: modifiedByLastName,
                externalStatus: externalStatus,
                rankName: rankName
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYSINGLERESOURCE,
                    data: data
                })
            });
    };


    export function modifySingleResourceCCNAttributes(externalId, CCNFirstName, CCNLastName, CCNTitle, CCNEmail, CCNPhoneNumber, CCNNPINumber, CCNCellPhoneNumber, CCNAddress, CCNCity, CCNState, CCNZipCode, CCNPCP, CCNMDPCP, CCNMDPCPPracticeId, CCNPracticeId, CCNPracticeNPI, CCNPracticePhoneNumber, CCNEPICDeptName, CCNEmployedOrIndependent, CCNCertificationStatus, CCNHaloStatus, CCNMSOStatus, CCNEVIPSPrimarySpecialty, CCNFY18HCIPDateCompleted, CCNFY19HCIPDateCompleted, CCNFY20HCIPDateCompleted, CCNFY20ECIPDateCompleted, CCNPAReceivedDate, CCNPAReturnedDate, CCNPAReceivedDatePracticeLevel, CCNCCNCredentialedDate, CCNCCNTerminationDate, CCNCareFirstMedicareAdvantagePlanEnrollmentDate, CCNCIGNAEnrollmentDate, CCNECIPEnrollmentDate, CCNTIN, CCNACO, CCNCRISPTier3) {
        fetch('api/App/modifySingleResourceCCNAttributes', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                CCNFirstName: CCNFirstName,
                CCNLastName: CCNLastName,
                CCNTitle: CCNTitle,
                CCNEmail: CCNEmail,
                CCNPhoneNumber: CCNPhoneNumber,
                CCNNPINumber: CCNNPINumber,
                CCNCellPhoneNumber: CCNCellPhoneNumber,
                CCNAddress: CCNAddress,
                CCNCity: CCNCity,
                CCNState: CCNState,
                CCNZipCode: CCNZipCode,
                CCNPCP: CCNPCP,
                CCNMDPCP: CCNMDPCP,
                CCNMDPCPPracticeId: CCNMDPCPPracticeId,
                CCNPracticeId: CCNPracticeId,
                CCNPracticeNPI: CCNPracticeNPI,
                CCNPracticePhoneNumber: CCNPracticePhoneNumber,
                CCNEPICDeptName: CCNEPICDeptName,
                CCNEmployedOrIndependent: CCNEmployedOrIndependent,
                CCNCertificationStatus: CCNCertificationStatus,
                CCNHaloStatus: CCNHaloStatus,
                CCNMSOStatus: CCNMSOStatus,
                CCNEVIPSPrimarySpecialty: CCNEVIPSPrimarySpecialty,
                CCNFY18HCIPDateCompleted: CCNFY18HCIPDateCompleted,
                CCNFY19HCIPDateCompleted: CCNFY19HCIPDateCompleted,
                CCNFY20HCIPDateCompleted: CCNFY20HCIPDateCompleted,
                CCNFY20ECIPDateCompleted: CCNFY20ECIPDateCompleted,
                CCNPAReceivedDate: CCNPAReceivedDate,
                CCNPAReturnedDate: CCNPAReturnedDate,
                CCNPAReceivedDatePracticeLevel: CCNPAReceivedDatePracticeLevel,
                CCNCCNCredentialedDate: CCNCCNCredentialedDate,
                CCNCCNTerminationDate: CCNCCNTerminationDate,
                CCNCareFirstMedicareAdvantagePlanEnrollmentDate: CCNCareFirstMedicareAdvantagePlanEnrollmentDate,
                CCNCIGNAEnrollmentDate: CCNCIGNAEnrollmentDate,
                CCNECIPEnrollmentDate: CCNECIPEnrollmentDate,
                CCNTIN: CCNTIN,
                CCNACO: CCNACO,
                CCNCRISPTier3: CCNCRISPTier3
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_MODIFYSINGLERESOURCECCNATTRIBUTES,
                    data: data
                })
            });
    };



    export function createSingleResource(resourceName, resourceType, reportType, qrsYear, reportLocation, externalStatus, overviewFullText, createdByFirstName, createdByLastName) {
        fetch('api/App/createSingleResource', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                resourceName: resourceName,
                resourceType: resourceType,
                reportType: reportType,
                qrsYear: qrsYear,
                reportLocation: reportLocation,
                externalStatus: externalStatus,
                overviewFullText: overviewFullText,
                createdByFirstName: createdByFirstName,
                createdByLastName: createdByLastName
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_CREATESINGLERESOURCE,
                    data: data
                })
            });
    };



    export function getSingleResourceDisplaysIn(externalId, siteMode) {
        fetch('api/App/getSingleResourceDisplaysIn', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                externalId: externalId,
                siteMode: siteMode
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_SINGLERESOURCE_DISPLAYSININFO,
                    data: data
                })
            });
    };


    export function manualResyncAllResources(idUser) {
        fetch('api/App/manualResyncAllResources', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                idUser: idUser
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_MANUALALLSYNC,
                    data: data
                })
            });
    };


    export function getResourceImages() {
        fetch('api/App/getResourceImages', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_THUMB_IMAGEINFO,
                    data: data
                })
            });
    };

    export function getResourceFullImages() {
        fetch('api/App/getResourceFullImages', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_FULLIMAGEINFO,
                    data: data
                })
            });
    };

    export function getUserHighScores(domain, username) {
        fetch('api/App/getUserHighScores', {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                domain: domain,
                username: username
            })
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_HIGHSCOREINFO,
                    data: data
                })
            });
    };

    export function getTopUsersHighScores() {
        fetch('api/App/getTopUsersHighScores', {
            method: "GET",
            headers: { "Content-Type": "application/json; charset=utf-8" }
        })
            .then(response => response.json())
            .then(data => {
                dispatcher.dispatch({
                    type: ACTIONS.UPDATE_USER_TOPUSERSHIGHSCOREINFO,
                    data: data
                })
            });
    };

    export function getLocationInfo() {
        var Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET", "https://geolocation-db.com/json/", false);
        Httpreq.send(null);
        return JSON.parse(Httpreq.responseText);
    };


    export function getWeatherInfoByLatLong(locationLatitude, locationLongitude) {
        var Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET", "https://api.openweathermap.org/data/2.5/weather?lat=" + locationLatitude + "&lon=" + locationLongitude + "&APPID=3f8d27d3db14a7a9f3bbdf9b0bed6c90&units=imperial", false);
        Httpreq.send(null);
        return JSON.parse(Httpreq.responseText);
    };

    export function getWeatherInfoByZip(locationZipCode) {
        var Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET", "https://api.openweathermap.org/data/2.5/weather?zip=" + locationZipCode + ",us&APPID=3f8d27d3db14a7a9f3bbdf9b0bed6c90&units=imperial", false);
        Httpreq.send(null);
        return JSON.parse(Httpreq.responseText);
    };